<template>
  <v-layout>
    <v-row>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.city"
            label="Miasto"
            placeholder=" "
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-autocomplete
            class="mt-0 pt-0"
            v-model="standardFilters.category"
            label="Kategoria"
            :items="categories"
            item-value="id"
            item-text="name"
            hide-details
        ></v-autocomplete>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import {setDatatableFilters} from "@/utils/helpers";
import debounce from "debounce";
import api from "@/services/api";

export default {
  data() {
    return {
      standardFilters: {
        category: null,
      },
      debouncedFilters: {
        city: '',
      },
      async loadCategories() {
        api
            .get('/api/categories?level=0')
            .then((data) => {
              this.categories = data.data.categories;
            })
            .catch((error) => {
              console.error('Error when loading categories: ', error);
            })
      },
      categories: [],
    };
  },
  created() {
    this.loadCategories();
    this.filterServicesDebouncing = debounce(function () {
      this.filterServices();
    }, 500);
  },
  watch: {
    standardFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterServices();
      },
      deep: true
    },
    debouncedFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterServicesDebouncing();
      },
      deep: true
    },
  },
  methods: {
    filterServices() {
      this.$root.$emit('loadServices', {
        filters: {
          ...this.standardFilters,
          ...this.debouncedFilters,
        },
        onSuccess: () => {
          this.$root.$emit('notify', {
            html: 'Filtrowanie zakończone.',
          });
        }
      });
    },
  }
}
</script>